import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  getMarketResearchProduct,
  getProductList,
  getScannedDocuments,
  removeProductMapping,
  submitProductMapping,
  webscrappingTyreData,
} from "_controllers/officer";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import { toastMessage } from "utils/toastMessage";
import authAxios from "setups/axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchOfficersList } from "slices/officers";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachmentIcon from "@mui/icons-material/Attachment";
import axios from "axios";
import { schemeConstants } from "config/constants";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import * as XLSX from "xlsx";
import writeXlsxFile from "write-excel-file";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import exportExcel from "utils/excelGenerate";

// const messageStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "75%",
//   maxHeight: "80vh",
//   overflowY: "auto",
//   bgcolor: "white",
//   boxShadow: 24,
//   p: 2,
//   textAlign: "center",
// };

const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  width: "35%",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const messageStyle1 = {
  position: "absolute",
  top: "50%",
  width: "75%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 2,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const brandList = ["MRF", "CEAT", "APOLLO", "TYRE-DEKHO"];
const category = ["CAR", "TRUCK", "2/3W", "FARM", "JEEP"];
const category1 = ["MRF", "CEAT", "APOLLO"];
const tyreCategoryList = ["SCV", "Car", "LCV", "TRUCK", "FARM", "2/3W"];

const Main = () => {
  const [data, setData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [image, setImage] = useState("");

  const [schemeData, setSchemeData] = useState();

  const [categories, setCategories] = useState([]);
  const [spendLimit, setSpendLimit] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");

  const [syncBrand, setSyncBrand] = useState("");
  const [syncCategory, setSyncCategory] = useState("");

  const [comparisonData, setComparisonData] = useState();
  const [openComparisonModal, setOpenComparisonModal] = useState(false);
  const [selectedTyre, setSelectedTyre] = useState("");

  const [matchedData, setMatchedData] = useState();
  const [openMatchingModal, setOpenMatchingModal] = useState(false);

  const [materiallist, setMateriallist] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState("");

  const [syncErr, setsyncErr] = useState({
    brand: false,
    category: false,
  });

  let columns = useMemo(() => [
    {
      headerName: "Brand Name",
      flex: 1,
    },
    {
      headerName: "Category",
      flex: 1,
    },
    {
      headerName: "Price",
      flex: 2,
    },
    {
      headerName: "Size",
      flex: 1,
    },
    {
      headerName: "Mapped",
      flex: 1,
    },
    {
      headerName: "Scrapped",
      flex: 1,
    },
    // {
    //   headerName: "Action",
    //   flex: 1,
    // },
  ]);

  const Validate = () => {
    let value = true;
    let err = {};

    if (syncBrand === "") {
      err.brand = "Please Select Brand.";
      value = false;
    }

    if (syncCategory === "") {
      err.category = "Please Select Category.";
      value = false;
    }
    setsyncErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const survey = await getMarketResearchProduct({
      currentPage,
      search,
      filter: selectedBrand,
    });
    setData(survey?.data);
    setCsvData(survey?.csvdata);
    setMessage(survey?.message);
    setLoading(true);
    setTotalPages(survey?.totalPage ?? 1);
  }, [message, currentPage, search, selectedBrand]);

  useEffect(async () => {
    const products = await getProductList({
      search: searchProduct,
    });
    setMateriallist(products?.data);
    setMessage(products?.message);
  }, [searchProduct]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    let updatedCategories = categories.map((category) => {
      let roSpendLimit = spendLimit.find((obj) => obj.role === role);
      if (roSpendLimit) {
        let updatedSubCategory = category.subCategory.map((subCategory) => {
          let matchedSubCategory = roSpendLimit.spendLimit
            .find((s) => s.category === category._id)
            ?.subCategory.find((sub) => sub.subCategory === subCategory._id);
          if (matchedSubCategory) {
            return { ...subCategory, amount: matchedSubCategory.amount };
          }
          return subCategory;
        });
        return { ...category, subCategory: updatedSubCategory };
      }
      return category;
    });
    setCategories(updatedCategories);
  }, [role]);

  const handleSyncSubmit = async () => {
    if (Validate()) {
      console.log("inside");
      await webscrappingTyreData({
        syncBrand,
        syncCategory,
      })
        .then((res) => {
          setMessage(res?.message);
          toastMessage(res?.message, "success");
          setSyncBrand("");
          setSyncCategory("");
          setOpenModal(false);
        })
        .catch((err) => {
          setMessage(err?.message);
          toastMessage(err?.message, "error");
          setSyncBrand("");
          setSyncCategory("");
          setOpenModal(false);
        });
    } else {
      setsyncErr({
        brand: true,
        category: true,
      });
    }
  };

  const handleSubmitMapping = async () => {
    // if (Validate()) {
    await submitProductMapping({
      selectedTyre,
      selectedMaterial,
    })
      .then((res) => {
        setMessage(res?.message);
        toastMessage(res?.message, "success");
        setOpenComparisonModal(false);
      })
      .catch((err) => {
        setMessage(err?.message);
        toastMessage(err?.message, "error");
        setOpenComparisonModal(false);
      });
    // } else {
    // setsyncErr({
    //   brand: true,
    //   category: true,
    // });
    // }
  };
  const handleRemove = async (product, materialno) => {
    await removeProductMapping({
      product,
      materialno,
    })
      .then((res) => {
        setMessage(res?.message);
        toastMessage(res?.message, "success");
        setOpenMatchingModal(false);
      })
      .catch((err) => {
        setMessage(err?.message);
        toastMessage(err?.message, "error");
        setOpenMatchingModal(false);
      });
  };

  const generateExcel = async (e) => {
    e.preventDefault();
    let fileName = "Product Mapping";
    exportExcel(
      csvData.map((x) => {
        let scrappedProduct = {};
        x?.allProducts && x?.allProducts.length > 0
          ? x?.allProducts.map((item, idx) => {
              scrappedProduct[`Company ${idx + 1}`] = item.companyName;
              scrappedProduct[`Product Name ${idx + 1}`] = item.productName;
              scrappedProduct[`Product Size ${idx + 1}`] = item.productSize;
              scrappedProduct[`Product Price ${idx + 1}`] =
                item.productPrice ?? 0;
              scrappedProduct[`Product Description ${idx + 1}`] =
                item.productDescription;
            })
          : null;

        let mappedProduct = {};
        x?.matchedProducts && x?.matchedProducts.length > 0
          ? x?.matchedProducts.map((item, idx) => {
              mappedProduct[`Company ${idx + 1}`] = item.companyName;
              mappedProduct[`Product Name ${idx + 1}`] = item.productName;
              mappedProduct[`Product Size ${idx + 1}`] = item.productSize;
              mappedProduct[`Product Price ${idx + 1}`] =
                item.productPrice ?? 0;
              mappedProduct[`Product Description ${idx + 1}`] =
                item.productDescription;
            })
          : null;

        return {
          "Material No": x?.materialNo,
          "Material Desc": x.productName,
          Category: x.tyreCategory,
          Size: x.productSize,
          Price: x.productPrice ?? 0,
          ...scrappedProduct,
          ...mappedProduct,
        };
      }),
      fileName
    );
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#F4F4F4",
          padding: "1rem",
          marginRight: "1rem",
          lineHeight: "2rem",
          borderRadius: "5px",
        }}
      >
        <div>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bolder",
              color: "#0E132F",
              fontWeight: "700",
              fontFamily: "Poppins",
            }}
          >
            Market Research
          </p>
        </div>
        <div
          style={{
            width: "100%",
            border: "1.5px solid grey",
          }}
        />

        {/* <div
          style={{
            display: "flex",
            justifyContent: "end",
            margin: "1rem 0",
          }}
        >
          <Button variant="contained">Download Sample</Button>
        </div> */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <TextField
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            name="search"
            variant="outlined"
            label="Search by SKU"
            size="small"
            style={{ width: "25%" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div>
            <FormControl sx={{ width: "200px", mr: 5 }} size="small">
              <InputLabel id="zone-label">Filter by Product Type</InputLabel>
              <Select
                labelId="zone-label"
                value={selectedBrand}
                name="selectedBrand"
                // sx={{ padding: "5px 1px" }}
                fullWidth
                size="small"
                onChange={(event) => setSelectedBrand(event.target.value)}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {tyreCategoryList?.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button variant="contained" onClick={() => setOpenModal(true)}>
              Sync Product
            </Button>
            <Button
              variant="contained"
              style={{ marginLeft: "1rem" }}
              onClick={generateExcel}
            >
              Download
            </Button>
          </div>
        </div>

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "58vh",
            overflowY: "auto",
            marginTop: "1rem",
          }}
        >
          <Table>
            {columns && columns.length > 0 ? (
              <TableHead>
                <TableRow>
                  {columns.map((item, idx) => (
                    <TableCell
                      align={idx === 0 ? "left" : "center"}
                      sx={{ fontWeight: "bolder" }}
                      key={idx}
                    >
                      {item.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            ) : null}

            <TableBody>
              {data && data?.length > 0 ? (
                data?.map((d) => (
                  <TableRow key={d?._id}>
                    <TableCell align="left">{d?.productName}</TableCell>
                    <TableCell align="center">{d?.tyreCategory}</TableCell>
                    <TableCell align="center">
                      ₹ {d?.productPrice ? d?.productPrice : 0}
                    </TableCell>
                    <TableCell align="center">{d?.tyreSize}</TableCell>
                    <TableCell align="center">
                      <VisibilityIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenMatchingModal(true);
                          setMatchedData(d);
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <VisibilityIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenComparisonModal(true);
                          setComparisonData(d?.allProducts);
                        }}
                      />
                    </TableCell>
                    {/* <TableCell
                      align="center"
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <EditIcon
                        sx={{
                          border: "1px solid darkgrey",
                          fontSize: "28px",
                          borderRadius: "3px",
                          cursor: "pointer",
                          color: "green",
                        }}
                      />
                      <DeleteIcon
                        sx={{
                          border: "1px solid darkgrey",
                          fontSize: "28px",
                          borderRadius: "3px",
                          cursor: "pointer",
                          color: "red",
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <Box sx={{ textAlign: "left", pt: 1 }}>
                  <Typography variant="h6" sx={{ p: 1 }}>
                    No Data.
                  </Typography>
                </Box>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid justifyContent={"center"} container p={1}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Grid>
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={messageStyle}>
          <div
            style={{
              borderBottom: "2px solid #e8e8e8",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.2rem",
              fontWeight: "bold",
              paddingBottom: "0.5rem",
            }}
          >
            <Typography variant="h6">Sync Product</Typography>
            <button
              style={{
                fontWeight: "600",
                fontSize: "24px",
                color: "red",
                border: "2px solid darkgrey",
                padding: "4px 8px",
                borderRadius: "3px",
                cursor: "pointer",
              }}
              onClick={() => setOpenModal(false)}
            >
              X
            </button>
          </div>
          <div>
            <Typography sx={{ marginTop: "20px", fontSize: "16px" }}>
              Brand Name
            </Typography>
            <TextField
              select
              name="syncBrand"
              value={syncBrand}
              onChange={(e) => setSyncBrand(e.target.value)}
              label="Select an Option"
              fullWidth
              sx={{ marginTop: "10px" }}
              error={syncErr.brand}
              helperText={syncErr.brand}
            >
              {brandList.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <Typography sx={{ marginTop: "20px", fontSize: "16px" }}>
              Category
            </Typography>
            <TextField
              select
              name="syncCategory"
              value={syncCategory}
              onChange={(e) => setSyncCategory(e.target.value)}
              label="Select an Option"
              fullWidth
              sx={{ marginTop: "10px" }}
              error={syncErr.category}
              helperText={syncErr.category}
            >
              {syncBrand === "TYRE-DEKHO"
                ? category1.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))
                : category.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
              {/* {category.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))} */}
            </TextField>

            <div style={{ marginTop: "1.5rem" }}>
              <button
                style={{
                  width: "70px",
                  height: "38px",
                  padding: "10px 20px",
                  backgroundColor: "#7367F0",
                  borderRadius: "6px",
                  color: "#fff",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
                onClick={() => handleSyncSubmit()}
              >
                Sync
              </button>
              <button
                style={{
                  width: "100px",
                  height: "38px",
                  padding: "10px 20px",
                  backgroundColor: "rgba(234, 84, 85, 0.16)",
                  borderRadius: "6px",
                  color: "rgba(234, 84, 85, 1)",
                  fontWeight: "500",
                  marginLeft: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSyncBrand("");
                  setSyncCategory("");
                }}
              >
                Discard
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openComparisonModal}
        onClose={() => setOpenComparisonModal(false)}
      >
        <Box sx={messageStyle1}>
          <div
            style={{
              borderBottom: "2px solid #e8e8e8",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.2rem",
              fontWeight: "bold",
              paddingBottom: "0.5rem",
            }}
          >
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Market Research Products
            </Typography>
            <button
              onClick={() => setOpenComparisonModal(false)}
              style={{
                fontWeight: "600",
                fontSize: "24px",
                color: "red",
                border: "2px solid darkgrey",
                padding: "4px 8px",
                borderRadius: "3px",
                cursor: "pointer",
              }}
            >
              X
            </button>
          </div>
          <div
            style={{
              padding: "1rem 0",
              display: "flex",
              justifyContent: "space-between",
              // maxHeight: "60vh",
              // overflowY: "auto",
            }}
          >
            <div
              style={{
                width: "49%",
                border: "1px solid #e8e8e8",
                borderRadius: "5px",
              }}
            >
              <div
                style={{
                  padding: "1rem",
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                {comparisonData && comparisonData.length > 0
                  ? comparisonData.map((product, idx) => (
                      <>
                        <div
                          style={{
                            padding: "1rem",
                            display: "flex",
                            justifyContent: "space-between",
                            boxShadow: `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
                            marginTop: `${idx > 0 ? "1rem" : "0"}`,
                          }}
                        >
                          <div
                            style={{
                              textDecoration: `${
                                product?.matched ? "line-through" : "none"
                              }`,
                            }}
                          >
                            <p>
                              {product?.productName} ({product?.companyName})
                            </p>
                            <p style={{ fontSize: "12px" }}>
                              ₹ {product?.productPrice}
                            </p>
                            <p style={{ fontSize: "12px" }}>
                              {product?.productSize}
                            </p>
                            <p style={{ fontSize: "10px" }}>
                              {product?.productDescription}
                            </p>
                          </div>
                          <div>
                            <img
                              src={product?.productImage}
                              alt={product?.companyName}
                              style={{ width: "50px" }}
                            />
                            <Button
                              style={{
                                backgroundColor: `${
                                  selectedTyre?.productName ===
                                    product?.productName &&
                                  selectedTyre?.productPrice ===
                                    product?.productPrice
                                    ? "grey"
                                    : "#EEC858"
                                }`,
                                padding: "8px 10px",
                                borderRadius: "4px",
                                height: "24px",
                                width: "60px",
                                color: "#54575E",
                                fontWeight: "600",
                                cursor: "pointer",
                                fontSize: "12px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "10px",
                              }}
                              disabled={
                                selectedTyre?.productName ===
                                  product?.productName &&
                                selectedTyre?.productPrice ===
                                  product?.productPrice
                                  ? true
                                  : false
                              }
                              onClick={() => setSelectedTyre(product)}
                            >
                              SELECT
                            </Button>
                          </div>
                        </div>
                      </>
                    ))
                  : null}
              </div>
            </div>
            <div
              style={{
                width: "49%",
                border: "1px solid #e8e8e8",
                borderRadius: "5px",
                padding: "1rem",
              }}
            >
              <TextField
                id="standard-basic"
                // label="Tyre Name"
                value={
                  selectedTyre !== undefined ? selectedTyre?.productName : ""
                }
                variant="outlined"
                disabled="true"
                fullWidth
              />
              <p style={{ textAlign: "center", margin: "1rem 0" }}>V/S</p>
              <Autocomplete
                id="tags-outlined"
                options={materiallist}
                getOptionLabel={(option) => `${option?.matDesc}`}
                onChange={(event, newValue) =>
                  setSelectedMaterial(newValue?.matnr)
                }
                sx={{ width: "100%", marginTop: "1rem" }}
                renderInput={(params) => (
                  <>
                    <TextField
                      {...params}
                      variant="outlined"
                      label={"Select Material SKU"}
                      placeholder="Material No"
                      onChange={(e) => setSearchProduct(e.target.value)}
                    />
                  </>
                )}
              />

              <div
                style={{
                  display: "flex",
                  marginTop: "1rem",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#EEC858",
                    padding: "12px 18px",
                    borderRadius: "4px",
                    height: "36px",
                    width: "100px",
                    color: "#54575E",
                    fontWeight: "600",
                    cursor: "pointer",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                  disabled={selectedTyre === undefined ? true : false}
                  onClick={() => handleSubmitMapping()}
                >
                  SUBMIT
                </Button>
                <Button
                  style={{
                    backgroundColor: "#636873",
                    padding: "12px 18px",
                    borderRadius: "4px",
                    height: "36px",
                    width: "100px",
                    color: "#fff",
                    fontWeight: "600",
                    cursor: "pointer",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px",
                    marginLeft: "2rem",
                  }}
                  disabled={selectedTyre === undefined ? true : false}
                  onClick={() => {
                    setSelectedTyre();
                    console.log("inside1");
                  }}
                >
                  CANCEL
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openMatchingModal}
        onClose={() => setOpenMatchingModal(false)}
      >
        <Box sx={messageStyle1}>
          <div
            style={{
              borderBottom: "2px solid #e8e8e8",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.2rem",
              fontWeight: "bold",
              paddingBottom: "0.5rem",
            }}
          >
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Products Mapped With JK Tyre
            </Typography>
            <button
              onClick={() => setOpenMatchingModal(false)}
              style={{
                fontWeight: "600",
                fontSize: "24px",
                color: "red",
                border: "2px solid darkgrey",
                padding: "4px 8px",
                borderRadius: "3px",
                cursor: "pointer",
              }}
            >
              X
            </button>
          </div>
          <div
            style={{
              border: "1px solid #e8e8e8",
              borderRadius: "5px",
              marginTop: "1rem",
            }}
          >
            <div
              style={{
                padding: "1rem",
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              {matchedData?.matchedProducts &&
              matchedData?.matchedProducts.length > 0
                ? matchedData?.matchedProducts.map((product, idx) => (
                    <>
                      <div
                        style={{
                          padding: "1rem",
                          display: "flex",
                          justifyContent: "space-between",
                          boxShadow: `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
                          marginTop: `${idx > 0 ? "1rem" : "0"}`,
                        }}
                      >
                        <div
                          style={{
                            textDecoration: `${
                              product?.matched ? "line-through" : "none"
                            }`,
                          }}
                        >
                          <p>
                            {product?.productName} ({product?.companyName})
                          </p>
                          <p style={{ fontSize: "12px" }}>
                            ₹ {product?.productPrice}
                          </p>
                          <p style={{ fontSize: "12px" }}>
                            {product?.productSize}
                          </p>
                          <p style={{ fontSize: "10px" }}>
                            {product?.productDescription}
                          </p>
                        </div>
                        <div>
                          <img
                            src={product?.productImage}
                            alt={product?.companyName}
                            style={{ width: "50px" }}
                          />
                          <Button
                            style={{
                              backgroundColor: "#EEC858",
                              padding: "8px 10px",
                              borderRadius: "4px",
                              height: "24px",
                              width: "60px",
                              color: "#54575E",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontSize: "12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                            disabled={
                              selectedTyre?.productName ===
                                product?.productName &&
                              selectedTyre?.productPrice ===
                                product?.productPrice
                                ? true
                                : false
                            }
                            onClick={() =>
                              handleRemove(product, matchedData?.materialNo)
                            }
                          >
                            REMOVE
                          </Button>
                        </div>
                      </div>
                    </>
                  ))
                : null}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

const MarketResearch = () => {
  return (
    <AccessController roles={["ADMIN", "AO"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default MarketResearch;
